<template>
  <b-card class="rounded-lg">
    <div class="d-flex align-items-center justify-content-end">
      <div>
        <UserViewActionCard :user-data="patientData" @update-user-data="$emit('update-user-data', $event)"></UserViewActionCard>
      </div>
    </div>

    <div class="card-body">
      <b-row>
        <b-col cols="12" md="7" class="px-3">
          <div class="text-center">
            <b-avatar 
              ref="previewEl" 
              size="10rem" 
              variant="light-success" 
              src=""
              :text="avatarText(`${getValueFromSource(patientData, 'full_name')}`)" 
            />

            <h2 class="mt-2 text-dark">
              {{ getValueFromSource(patientData, 'full_name') }}
            </h2>

            <h5 class="mt-2 text-dark">
              <mark>{{ startCase(getValueFromSource(patientData, 'gender')) }}</mark>
            </h5>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="w-50">
              <h5 class="lead text-muted">
                DOB
              </h5>

              <h5 class="text-dark">
                {{ getValueFromSource(patientData, 'date_of_birth') }}
              </h5>
            </div>

            <div class="w-50">
              <h5 class="lead text-muted text-right">
                Age
              </h5>

              <h5 class="text-dark text-right">
                {{ calculateAge( new Date(getValueFromSource(patientData, 'date_of_birth'))) }}<sub>y</sub>
              </h5>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="w-50">
              <h5 class="lead text-muted">
                Weight
              </h5>

              <h5 class="text-dark">
                <p v-if="getValueFromSource(consultationData, 'anthropometric_data.weight')">
                  {{ getValueFromSource(consultationData, 'anthropometric_data.weight') }}<sub>kg</sub>
                </p>
    
                <p v-else>
                  N/A
                </p>
              </h5>
            </div>

            <div class="w-50">
              <h5 class="lead text-muted text-right">
                Height
              </h5>

              <h5 class="text-dark text-right">
                <p v-if="getValueFromSource(consultationData, 'anthropometric_data.height')">
                  {{ getValueFromSource(consultationData, 'anthropometric_data.height') }}<sub>cm</sub>
                </p>
    
                <p v-else>
                  N/A
                </p>
              </h5>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <b-button
              size="lg"
              pill
              variant="primary"
              class="mt-2 mr-2"
            >
              <feather-icon
                icon="MailIcon"
                size="20"
              />
              <span class="ml-25 align-middle">Message</span>
            </b-button>
    
            <b-button
              size="lg"
              pill
              variant="primary"
              class="mt-2"
            >
              <feather-icon
                icon="VideoIcon"
                size="22"
              />
              <span class="ml-25 align-middle">Chat</span>
            </b-button>
          </div>

        </b-col>

        <b-col cols="12" md="5" style="border-left: 2px solid rgb(238, 238, 238);" class="pl-2">
          <div class="mb-5">
            <h5 class="lead text-muted">
              Home Address
            </h5>

            <h4 class="text-dark">
              {{ getValueFromSource(patientData, 'home_address', 'N/A') || 'N/A' }}
            </h4>
          </div>

          <div class="mb-5">
            <h5 class="lead text-muted">
              Mobile Phone #
            </h5>

            <h4>
              <b-link v-if="patientData.phone" :href="`tel:${patientData.phone}`">
                {{ getValueFromSource(patientData, 'phone') }}
              </b-link>
  
              <span v-else>
                N/A
              </span>
            </h4>
          </div>

          <div class="mb-5">
            <h5 class="lead text-muted">
              Work Phone #
            </h5>

            <h4>
              <b-link v-if="patientData.work_phone" :href="`tel:${patientData.work_phone}`">
                {{ getValueFromSource(patientData, 'work_phone') }}
              </b-link>
  
              <span v-else>
                N/A
              </span>
            </h4>
          </div>

          <div class="mb-3">
            <h5 class="lead text-muted">
              Email
            </h5>

            <h4 class="text-dark">
              <b-link v-if="patientData.email" :href="`mailto:${patientData.email}`">
                {{ getValueFromSource(patientData, 'email') }}
              </b-link>

              <span v-else>
                N/A
              </span>
            </h4>
          </div>

          <div class="mb-3">
            <h5 class="text-muted">
              Insurance Name
            </h5>

            <h4 class="lead text-dark">
              {{ getValueFromSource(patientData, 'insurance_name', 'N/A') || 'N/A' }}
            </h4>
          </div>

          <div class="mb-3">
            <h5 class="text-muted">
              Policy Number
            </h5>

            <h4 class="lead text-dark">
              {{ getValueFromSource(patientData, 'policy_number', 'N/A') || 'N/A' }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BLink,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import { startCase } from 'lodash';
import UserViewActionCard from "./UserViewActionCard.vue";

export default {
  components: {
    UserViewActionCard,
    BCard,
    BRow,
    BLink,
    BCol,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BDropdownGroup
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    consultationData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  methods: {
    startCase
  }
}
</script>

